module.exports = __webpack_public_path__ + "img/seta.6f4909b1.svg";